<template>
  <tr class="document-list-item">
    <td
      v-if="documentType === 'passports'"
      class="align-middle">
      <d-badge
        v-if="documentData.is_default"
        theme="dark"
        :outline="true">
        Default document
      </d-badge>
      <a
        v-else
        href="#"
        @click="setAsDefaultDocument(documentData.id, documentData.reference_type, documentData.reference_id)"
        :class="{
          'is-locked': setAsDefaultInProgress
        }">
        <span
          v-if="setAsDefaultInProgress === documentData.id"
          class="spinner-item"></span>
        Set as default
      </a>
    </td>
    <td class="align-middle">
      {{ documentData.name }}
    </td>
    <td class="align-middle" :style="documentType === 'documents' ? 'width: 160px;' : ''">{{ documentData.serial_number }}</td>
    <td class="align-middle" style="width: 160px;">{{ documentData.nationality }}</td>
    <td class="align-middle" style="width: 120px;">
      <span :class="{ 'text-warning': dateHasWarningState(documentData.expiry), 'text-danger': dateHasDangerState(documentData.expiry) }">
        {{ documentData.expiry }}
      </span>
    </td>
    <td style="width: 140px;" class="align-middle">
      <d-button
        theme="primary"
        @click.native="editDocument"
        class="mr-2"
        title="Edit">
        <i class="material-icons">edit</i>
      </d-button>
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removeDocument"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'documents-list-item',
  props: {
    documentType: {
      type: String,
      required: true
    },
    documentData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    documentTypeName () {
      if (this.documentType === 'documents-licences') {
        return 'license';
      }

      if (this.documentType === 'passports') {
        return 'passport';
      }

      return 'document';
    }
  },
  data () {
    return {
      removeInProgress: false,
      setAsDefaultInProgress: false
    };
  },
  methods: {
    removeDocument () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/' + this.documentType + '/delete/',
        id: parseInt(this.documentData.id, 10),
        successTitle: this.documentTypeName + ' removed',
        successText: 'The selected ' + this.documentTypeName + ' has been removed',
        confirmTitle: 'Do you really want to remove this ' + this.documentTypeName + '?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('documents-list-reload', this.documentType);
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    editDocument () {
      this.$bus.$emit('show-document-popup', 'edit', false, false, this.documentData.id, this.documentType);
    },
    dateHasWarningState (date) {
      date = +new Date(date);

      if (date - +new Date() < 180 * 24 * 60 * 60 * 1000 && date - +new Date() > 14 * 24 * 60 * 60 * 1000) {
        return true;
      }

      return false;
    },
    dateHasDangerState (date) {
      date = +new Date(date);

      if (date - +new Date() < 14 * 24 * 60 * 60 * 1000 || +new Date() > date) {
        return true;
      }

      return false;
    },
    setAsDefaultDocument (documentID, documentRefType, documentRefID) {
      if (this.setAsDefaultInProgress) {
        return;
      }

      let endpointUrl = '';
      this.setAsDefaultInProgress = documentID;

      if (documentRefType === 'PASSENGER') {
        endpointUrl = '/passengers/set-default/' + documentRefID;
      } else if (documentRefType === 'CREW') {
        endpointUrl = '/crews/set-default/' + documentRefID;
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: {
          document_type: 'passport',
          document_id: documentID
        },
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during submitting data. Please try again.',
        successAction: () => {
          this.setAsDefaultInProgress = false;
          this.$bus.$emit('documents-list-reload', 'passports');
        },
        failAction: () => {
          this.setAsDefaultInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.document-list-item {
  .is-locked {
    opacity: .5;
    pointer-events: none;
  }

  /deep/ .spinner-item {
    display: inline-block;
    height: 16px;
    width: 16px;
    animation: rotate 0.8s infinite linear;
    border: 2px solid #84899e;
    border-right-color: transparent;
    border-radius: 50%;
    position: relative;
    top: 2px;
  }
}

@keyframes rotate {
  0%    { transform: rotate(0deg); }
  100%  { transform: rotate(360deg); }
}
</style>
